import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Categories() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            内容分类导航
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            按您关心的话题浏览内容，快速找到所需信息
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat, index) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-white rounded-lg p-6 hover:bg-primary-50 transition-colors animate-fade-in-up cursor-pointer"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center shrink-0 group-hover:bg-accent-200 transition-colors">
                  <i className={`${cat.icon} text-lg text-accent-600`}></i>
                </div>
                <div>
                  <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-1.5 group-hover:text-primary-700 transition-colors">
                    {cat.name}
                  </h3>
                  <p className="text-foreground-500 text-xs leading-relaxed">
                    {cat.description}
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}